import { render } from "./ConferenceAvantPage.vue?vue&type=template&id=aa330b04"
import script from "./ConferenceAvantPage.vue?vue&type=script&lang=js"
export * from "./ConferenceAvantPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__